module.exports = __webpack_public_path__ + "static/media/spectre.aa02c461.png";